import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../../api';
import Drawer from '../UI/Drawer';
import { primaryBtn, primaryBtnStyle, ghostBtn, ghostBtnStyle, inputCls, inputStyle, fieldLabel, fieldLabelStyle, errMessage } from '../UI/ink';
import { PRIORITIES } from './model';

// Owner is picked from organisation members; the API rejects anyone else.
export default function NewCaseDrawer({ open, members, me, onClose }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: '', priority: 'medium', assigned_to: '', description: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => { if (open) { setForm({ title: '', priority: 'medium', assigned_to: me || '', description: '' }); setError(null); } }, [open, me]);
  const f = (k) => ({ value: form[k], onChange: e => setForm(x => ({ ...x, [k]: e.target.value })) });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) { setError('Give the case a title.'); return; }
    setBusy(true); setError(null);
    try {
      const r = await apiClient.post('/api/cases', { title: form.title.trim(), priority: form.priority, assigned_to: form.assigned_to || null, description: form.description.trim() || null });
      onClose();
      if (r.data?.id) navigate(`/cases/${r.data.id}`);
    } catch (err) {
      setError(errMessage(err, 'Could not create the case.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      kicker="CASES"
      title="New case"
      subtitle="Track an investigation in one place. You can link findings and alerts from the case page."
      footer={<><span /><div className="flex gap-2.5"><button type="button" onClick={onClose} className={ghostBtn} style={ghostBtnStyle}>Cancel</button><button type="submit" form="new-case" disabled={busy} className={primaryBtn} style={primaryBtnStyle}>{busy ? 'Creating…' : 'Create case'}</button></div></>}
    >
      <form id="new-case" onSubmit={submit} className="flex flex-col gap-5">
        {error && <div role="alert" className="px-3.5 py-2.5 rounded-[10px] border text-[13px]" style={{ borderColor: 'var(--sev-crit-fg)', color: 'var(--sev-crit-fg)', background: 'var(--sev-crit-bg)' }}>{error}</div>}
        <label className="flex flex-col gap-1.5"><span className={fieldLabel} style={fieldLabelStyle}>Title</span><input {...f('title')} autoFocus placeholder="e.g. C2 activity on the web tier" className={inputCls} style={inputStyle} /></label>
        <div className="grid grid-cols-2 gap-3">
          <label className="flex flex-col gap-1.5"><span className={fieldLabel} style={fieldLabelStyle}>Priority</span>
            <select {...f('priority')} className={inputCls} style={inputStyle}>{PRIORITIES.map(p => <option key={p} value={p}>{p[0].toUpperCase() + p.slice(1)}</option>)}</select>
          </label>
          <label className="flex flex-col gap-1.5"><span className={fieldLabel} style={fieldLabelStyle}>Owner</span>
            <select {...f('assigned_to')} className={inputCls} style={inputStyle}>
              <option value="">Unassigned</option>
              {members.map(m => <option key={m.email} value={m.email}>{m.full_name || m.email}{m.email === me ? ' (you)' : ''}</option>)}
            </select>
          </label>
        </div>
        <label className="flex flex-col gap-1.5"><span className={fieldLabel} style={fieldLabelStyle}>What’s it about <span className="font-normal" style={{ color: 'var(--ink-faint)' }}>(optional)</span></span>
          <textarea {...f('description')} rows={4} className="box-border px-3 py-2.5 rounded-[10px] border text-sm resize-none outline-none" style={inputStyle} />
        </label>
      </form>
    </Drawer>
  );
}
